var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('expansion-card',{attrs:{"title":_vm.title,"list":_vm.filteredSchema,"boxShadow":false},on:{"inputBlur":_vm.blurEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }